// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"dfa883bd","455":"d023205e"}[chunkId] + ".chunk.js";
};